export enum ESelectedPlan {
  "BATCH",
  "BATCH_WITH_PLUS",
}

export enum ECheckoutType {
  "BATCH",
  "PLUS",
}

export enum EBookNowComingFromPage {
  "BATCH_CHECKOUT_PAGE",
  "BATCH_CHECKOUT_BOOKING_PAGE",
  "LOGIN_PAGE",
  "PLUS_CHECKOUT",
}
